<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: ESM - EASY SCHOOL MANAGEMENT
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 sm:m-0 m-4">
      <vx-card class="login-principal">
        <div slot="no-body" class="full-page-bg-color  login-principal">

          <div class="vx-row no-gutter justify-center items-center login-principal">

            <!-- <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div> -->

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg  login-principal">
                
              <div class="px-8 pt-8 login-tabs-container">
                <div>
                  <img src="@/assets/images/logo/ESM.png" style="width: 290px;" class="ml-6" alt="Logo">
                </div>

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Se connecter</h4>
                  <p style="color: #111183;">Bienvenue à nouveau, veuillez vous connecter à votre compte.</p>

                  <!-- <h4 class="mb-4 mt-4">Nom d'utilisateur: <b style="color: #111183;"> desired </b> </h4>
                  <h4 class="mb-4">Mot de passe: <b style="color: #111183;"> desired </b></h4> -->
                </div>

                <div>
                  <vs-input
                      @keyup.enter="loginJWT()"
                      style="border-radius: 50%"
                      :danger="error.username || verificationusername"
                      name="username"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Nom d'utilisateur"
                      v-model="username"
                      class="w-full"/>
                  
                  <span v-if="verificationusername || error.username" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    <p style="margin-bottom: 4px !important; font-size: 13px">{{verificationusername ? 'Le nom d\'utilisateur est réquis.' : 'Nom d\'utilisateur ou Mot de passe incorrect.'}}</p>
                  </span>

                  <vs-input
                      @keyup.enter="loginJWT()"
                      :danger="error.password || verificationpassword"
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Mot de passe"
                      v-model="password"
                      class="w-full mt-6" />
                  
                  <span v-if="verificationpassword || error.password" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    <p style="margin-bottom: 4px !important; font-size: 13px">{{verificationpassword ? 'Le mot de passe est réquis.' : 'Nom d\'utilisateur ou Mot de passe incorrect.'}}</p>
                  </span>

                  <!-- <div class="flex flex-wrap justify-between my-5">
                      <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Se souvenir de moi</vs-checkbox>
                      <router-link to="/auth/password-reset">Mot de passe oublié?</router-link>
                  </div> -->
                  <vs-button class="float-right mb-8 w-full my-5" :disabled="!validateForm" @click="loginJWT()">Connexion</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
let base_self = ''

export default{
  data () {
    return {
      error: {
        username: false,
        password: false
      },
      username: '',
      password: '',
      checkbox_remember_me: false
    }
  },
  computed: {
    validateForm () {
      return base_self.username !== '' && base_self.password.length >= 0
    },
    verificationpassword () {
      return base_self.password.length === 0
    },
    verificationusername () {
      return base_self.username.length === 0
    }
  },
  methods: {
    loginUserName () {
      const params = { username: base_self.username, password: base_self.password }
      base_self.$store.state.login_Online(params)
        .then((response) => {
          localStorage.setItem('response_data_user_role', response.data.user.role)
          console.log(' ............................................................. response_data_user_role: sortie login')
          console.log(' ............................................................. response_data_user_role: sortie login')
          console.log(' ............................................................. response_data_user_role: sortie login')
          console.log(' ............................................................. response_data_user_role: sortie login')
          console.log(' ............................................................. response_data_user_role: sortie login')
          console.log(' ............................................................. response_data_user_role: sortie login')
          console.log(' ............................................................. response_data_user_role: sortie login')

          // console.log('response.data -----------: ', response.data.user.role)
          /* if (response.data.status) {
           
            console.log('response.data: ', response.data)
            window.getAgroTrack.success('Connexion avec succès', response)
          } else {
            base_self.error.username = true
            base_self.error.password = true
            // window.getAgroTrack.error(response.data)
          } */
          
          base_self.$store.dispatch('updateUserInfo', response.data)

          const routeData = base_self.$router.resolve({name: 'dashboard'})
          window.open(routeData.href, '_blank')
        })
        .catch((error) => {
          base_self.error.username = true
          base_self.error.password = true
          console.log('error: ', error)
        })
    },
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    loginJWT () {

      if (!this.checkLogin()) return

      // Loading
      this.$vs.loading()

      const data = {
        username: this.username,
        password: this.password
      }

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: 'admin@admin.com',
          password: 'adminadmin',
          data
        }
      }

      this.$store.dispatch('auth/loginJWT', payload)
        .then(() => {
          this.$vs.loading.close()
          window.getESM.initialisation()
        })
        .catch(error => {
          this.$http.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },
  async created () {
    base_self = this
  }
}
</script>


<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}

.login-principal {
  /* border: 2px solid red; */
  border-radius: 20px;
}
</style>
